import type React from "react";
import { useState } from "react";
import { themeData, type Theme } from "@/data/themeData";

const LearningThemes: React.FC = () => {
	const [selectedCategory, setSelectedCategory] = useState<Theme | null>(null);

	const handleCategoryClick = (category: Theme) => {
		setSelectedCategory(category);
	};

	const handleBackClick = () => {
		setSelectedCategory(null);
	};

	const handleKeyDown = (event: React.KeyboardEvent, category: Theme) => {
		if (event.key === "Enter" || event.key === " ") {
			handleCategoryClick(category);
		}
	};

	return (
		<section className="py-16 bg-gray-100">
			<div className="container mx-auto">
				<h2 className="text-3xl font-bold text-center mb-12">
					取り組むテーマは無限、あなたは何をしますか？
				</h2>
				{selectedCategory ? (
					<div className="animate-fade-in">
						<h3 className="text-2xl font-bold mb-4">
							{selectedCategory.category}
						</h3>
						<ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
							{selectedCategory.themes.map((theme) => (
								<li
									key={theme.id}
									className="bg-white p-4 rounded-lg shadow-md flex items-center hover:transform hover:-translate-y-1 transition-transform duration-200"
								>
									<span className="text-2xl mr-2">{theme.emoji}</span>
									<span>{theme.title}</span>
								</li>
							))}
						</ul>
						<button
							type="button"
							onClick={handleBackClick}
							className="mt-8 bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition-colors duration-200"
						>
							← カテゴリー一覧に戻る
						</button>
					</div>
				) : (
					<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 animate-fade-in">
						{themeData.map((category) => (
							<button
								type="button"
								key={category.id}
								onClick={() => handleCategoryClick(category)}
								onKeyDown={(e) => handleKeyDown(e, category)}
								className="bg-white p-4 rounded-lg shadow-md text-center cursor-pointer hover:transform hover:-translate-y-1 transition-transform duration-200"
							>
								<span className="text-4xl mb-2 block">{category.emoji}</span>
								<h3 className="text-lg font-semibold">{category.category}</h3>
							</button>
						))}
					</div>
				)}
			</div>
		</section>
	);
};

export default LearningThemes;
